import useEmblaCarousel from "embla-carousel-react";
import { WheelGesturesPlugin } from "embla-carousel-wheel-gestures";
import { CollectionCard } from "./CollectionCard";
import { useTopLevelCollections } from "@/hooks/queries/useTopLevelCollections";
export const CollectionCardGrid = () => {
  const {
    data
  } = useTopLevelCollections();
  const [emblaRef] = useEmblaCarousel({
    loop: false,
    skipSnaps: true,
    dragFree: true
  }, [WheelGesturesPlugin({
    forceWheelAxis: "x"
  })]);
  if (!data || data.items.length === 0) return null;
  return <div className="relative" data-sentry-component="CollectionCardGrid" data-sentry-source-file="CollectionCardGrid.tsx">
      <div ref={emblaRef}>
        <div className="flex gap-4">
          {data.items.map(collection => <div key={collection.id} className="min-w-0 flex-[0_0_60%] md:flex-[0_0_30%]">
              <CollectionCard collection={collection} />
            </div>)}
        </div>
      </div>
    </div>;
};